import { render, staticRenderFns } from "./selectUrl.vue?vue&type=template&id=287ae072&"
import script from "./selectUrl.vue?vue&type=script&lang=ts&"
export * from "./selectUrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports